<template>
  <el-container class="app-wrapper">
    <el-aside width="200px">
      <div class="logo">
        <img src="@/assets/logo.png" style="width: 30px;height: 30px;" alt="logo" />
        <span style="margin-left: 10px;">商旅新万人力资源服务</span>
      </div>
      <el-menu :default-active="$route.path" :router="true" class="el-menu-vertical" background-color="#304156"
        text-color="#bfcbd9" active-text-color="#409EFF">
        <template v-for="route in routes">
          <el-submenu v-if="route.children && route.children.length > 1" :key="route.path" :index="route.path">
            <template slot="title">
              <i :class="route.meta.icon"></i>
              <span>{{ route.meta.title }}</span>
            </template>
            <el-menu-item v-for="child in route.children" :key="child.path" :index="route.path + '/' + child.path">
              {{ child.meta.title }}
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :key="route.path" :index="route.path + '/' + route.children[0].path">
            <i :class="route.children[0].meta.icon"></i>
            <span slot="title">{{ route.children[0].meta.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { constantRoutes } from '@/router'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: 'Layout',
  data() {
    return {


    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/userInfo',
      authority: 'user/authority'
    }),
    // 需要支持深层的 children 的  hidden 的显示
    routes() {
     let routes = _.cloneDeep(constantRoutes)
      if (this.authority.length === 0) {
        return []
      }
      routes = routes.filter(route => {
        if (route.children) { 
          route.children = route.children.filter(child => {
            return !child.hidden && this.authority.includes(child.key)
          })
        }
        return !route.hidden && route.children.length 
      })
      return routes
    }
  },

  methods: {

    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-wrapper {
  height: 100vh;

  .el-aside {
    background-color: #304156;

    .el-menu {
      border-right: none;
    }
  }

  .el-header {
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .header-right {
      margin-right: 20px;

      .el-dropdown-link {
        cursor: pointer;
        color: #333;
      }
    }
  }

  .el-main {
    background-color: #f0f2f5;
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: 20px 0;
  color: #fff;
}
</style>